import { connect } from 'react-redux';
import { sourceSelector } from '../../selectors/source';
export function mapStateToProps(state) {
  return {
    source: sourceSelector(state)
  };
}
export var SourceProvider = connect(mapStateToProps);